// @file Surface Panels store.
import type { PopoverAnchor, PostCustomPropertyValue } from '@@/types'
import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

export const useSurfacePanelsStore = defineStore('surfacePanelsStore', () => {
  // State
  const xSurfaceDetailsPanel = ref(false)
  const xQrModal = ref(false)
  const xSurfaceSharePanel = ref(false)
  const xSurfaceRemakePanel = ref(false)
  const xSurfaceActivityPanel = ref(false)
  const xSurfaceGradingPanel = ref(false)
  const xSurfaceAutomationsPanel = ref(false)
  const xPhotoAlbumImagePicker = ref(false)
  const xPhotoAlbumEditorDialog = ref(false)
  const xMentionBox = ref(false)
  const xActionBarMoreMenu = ref(false)
  const xDevelopersPanel = ref(false)
  const xReportPanel = ref(false)
  const xEditBookmarksDialog = ref(false)

  // Phone number field method popover
  const xPhoneFieldMethodPopover = ref(false)
  const phoneFieldMethodPopoverAnchor = ref<PopoverAnchor | null>(null)
  const activePhoneNumberPopoverValue = ref<PostCustomPropertyValue | null>(null)

  function openPhoneNumberPopover({ value, anchor }: { value: PostCustomPropertyValue; anchor: PopoverAnchor }): void {
    activePhoneNumberPopoverValue.value = value
    xPhoneFieldMethodPopover.value = true
    phoneFieldMethodPopoverAnchor.value = anchor
  }

  function closePhoneNumberPopover(): void {
    xPhoneFieldMethodPopover.value = false
    phoneFieldMethodPopoverAnchor.value = null
    activePhoneNumberPopoverValue.value = null
  }

  function showMentionBox(): void {
    xMentionBox.value = true
  }

  function hideMentionBox(): void {
    xMentionBox.value = false
  }

  function showActionBarMoreMenu(): void {
    xActionBarMoreMenu.value = true
  }

  function hideActionBarMoreMenu(): void {
    xActionBarMoreMenu.value = false
  }

  function showDevelopersPanel(): void {
    xDevelopersPanel.value = true
  }

  function hideDevelopersPanel(): void {
    xDevelopersPanel.value = false
  }

  function showEditBookmarksDialog(): void {
    xEditBookmarksDialog.value = true
  }
  function hideEditBookmarksDialog(): void {
    xEditBookmarksDialog.value = false
  }

  return {
    // State
    xSurfaceDetailsPanel,
    xQrModal,
    xSurfaceActivityPanel,
    xSurfaceSharePanel,
    xSurfaceGradingPanel,
    xSurfaceRemakePanel,
    xSurfaceAutomationsPanel,
    xMentionBox,
    xActionBarMoreMenu,
    xDevelopersPanel,
    xReportPanel,
    xEditBookmarksDialog,

    xPhotoAlbumImagePicker,
    xPhotoAlbumEditorDialog,
    xPhoneFieldMethodPopover,
    phoneFieldMethodPopoverAnchor: readonly(phoneFieldMethodPopoverAnchor),
    activePhoneNumberPopoverValue: readonly(activePhoneNumberPopoverValue),

    // Actions
    openPhoneNumberPopover,
    closePhoneNumberPopover,
    showMentionBox,
    hideMentionBox,
    hideActionBarMoreMenu,
    showActionBarMoreMenu,
    showDevelopersPanel,
    hideDevelopersPanel,
    showEditBookmarksDialog,
    hideEditBookmarksDialog,
  }
})
